module.exports = __webpack_public_path__ + "static/venkataramana-d249e1b19fba8f910d0928985b7351da.png";